import App, {Tool} from "../App";
import Api from "./Api";
import Resource from "../Resource";

class Patient {
    static data(props) {
        App.log('PATIENT.DATA', App.LOG.FETCH, props);

        const body = {
            patientFileCode: props.patientFileCode
        };

        return new Promise((resolve, reject) => {
            fetch(Api.PATIENT.DATA, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        if (result.objList[0])
                            resolve(result.objList[0]);
                        else
                            reject('پرونده پیدا نشد.');
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static list() {
        App.log('PATIENT.LIST', App.LOG.FETCH);

        const body = {};

        return new Promise((resolve, reject) => {
            fetch(Api.PATIENT.LIST, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static updatePatient(props) {
        App.log('PATIENT.UPDATE_PATIENT', App.LOG.FETCH, props);

        const body = {
            fileCodeId: props.fileCodeId,
            genderId: props.genderId,
            birthDate: props.birthDate,
            nationalCode: props.nationalCode,
            fatherName: props.fatherName,
            patientBloodGroupId: props.patientBloodGroupId,
            cityId: props.cityId,
            provinceId: props.provinceId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.PATIENT.UPDATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static updatePatientState(props) {
        App.log('PATIENT.UPDATE_PATIENT_STATE', App.LOG.FETCH, props);

        const body = {
            fileCodeId: props.fileCodeId,
            statusId: props.statusId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.PATIENT.UPDATE_STATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }
}

export default Patient